import type {StoryblokStory} from 'storyblok-generate-ts';
import {getCommonStoryParams} from '~/storyblok/api/options';
import type {FooterStoryblok} from '~/storyblok/types';

export const useStoryblokFooterStore = defineStore('footer', () => {
	const {$storyblokApi, runWithContext} = useNuxtApp();

	const footer = ref<StoryblokStory<FooterStoryblok> | null>(null);

	async function fetchFooter() {
		try {
			const {data} = await $storyblokApi.get(
				`stories/${encodeURIComponent(encodeURIComponent('_globus-cz/komponenty/paticka'))}`,
				await runWithContext(getCommonStoryParams),
			);
			footer.value = data?.story ?? null;
			return footer.value;
		} catch (e: any) {
			// Leave the store empty and keep on rendering, the footer component can handle it gracefully
		}
	}

	return {
		footer,
		fetchFooter,
	};
});
